import React, { FC } from 'react';
import { SearchDrawerHeader } from './SearchDrawerHeader';
import { AsideFilters } from '../aside-filters/AsideFilters';
import { Connect, PropsFromRedux } from './SearchDrawerContainer';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { MobileFilters } from './MobileFilters';
import { SearchSort } from '../search-sort/SearchSort';
import styles from './search_drawer.module.scss';

type Props = PropsFromRedux;

export const RawSearchDrawer: FC<Props> = ({
  closeFilter,
  showFilters,
  selectedFiltersLength,
  resetFilters,
  exceptExpressions,
}) => {
  const onCloseFilters = (source: string) => () => {
    doctrineAnalytics('Search FilterClosed', { source });
    closeFilter();
  };

  return (
    <>
      <div className={styles.drawer}>
        <SearchDrawerHeader
          closeFilter={onCloseFilters('cross')}
          resetFilters={resetFilters}
          selectedFiltersLength={selectedFiltersLength}
        />

        {showFilters && (
          <div className={styles.main}>
            <MobileFilters exceptExpressions={exceptExpressions} />
            <SearchSort />
            <AsideFilters />
            <div className={styles.offset} />
          </div>
        )}
      </div>
      <div onClick={onCloseFilters('backdrop')} className={styles.overlay} />
    </>
  );
};

export const SearchDrawer = Connect(RawSearchDrawer);
